<template lang="pug">
shListData(title="Bonos de Clientes" resolver="bonuses" keyData="bonus" component="shBonus")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Bonuses',

  components: { shListData }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/bonus/Bonuses.vue